<div class="wishlist-item">
  <input class="wishlist" data-product-id="{{productId}}" type="checkbox" value="{{wishlistId}}" name="product_{{productId}}_wishlist[id][]" id="product_{{productId}}_wishlist_id_{{wishlistId}}" />
  <label for="product_{{productId}}_wishlist_id_{{wishlistId}}">{{ wishlistName }}</label>
</div>
